import '../styles/components/stat-box.scss';
import { Link } from "react-router-dom";

export default function StatBox({icon, title, number, linkTo, linkText}) {
    return (
        <div className="stat-box text-secondary">
            <div className="container">
                <div className="stats-row row justify-content-between">
                    <div className="icon col col-3 p-0">
                        {icon && <img className='box-icon' src={icon} alt=""/>}
                    </div>
                    <div className="col col-9 right">
                        <h1>{number}</h1>
                        <h2>{title}</h2>
                        <div className="link-row justify-content-end">
                            <Link to={linkTo} className="text-secondary">
                                {linkText}
                                <i className="bi bi-arrow-right-circle-fill"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
